/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { SPECTRUM } from 'constants/predicates';

import BooleanEdit from './BooleanEdit';

// SPEC-354 enable boolean only if "isParentCollection" checked
const IsIndependentCollectionEdit = ({ field }) => {
  const parentCollectionChecked = useSelector(state => 
    state.field.fields[SPECTRUM.IS_PARENT_COLLECTION]?.values[0] === true
  );

  useEffect(() => {
    field.setDisabled(!parentCollectionChecked);
  }, [parentCollectionChecked]);

  return <BooleanEdit field={field} />;
};

export default IsIndependentCollectionEdit;